<div >
  <mat-card class="matcard">
    <mat-card-content style="width: 100%;margin:auto">
      <div style="display: flex;flex-wrap: wrap">
        <div >
          <form >
            <mat-form-field appearance="outline" style="margin-right: 20px" >
              <mat-label>Proveedor</mat-label>
              <input type="text"
                     placeholder="Elige el proveedor"
                     matInput
                     required
                     [formControl]="proveedorControl"
                     [matAutocomplete]="autoProveedor"
              >
              <mat-autocomplete #autoProveedor="matAutocomplete" [displayWith]="getOptionText">
                <mat-option *ngFor="let proveedor of filteredOptionsProveedor | async" [value]="proveedor">
                  {{proveedor.nombre}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </form>
        </div>
        <form [formGroup]="ingresoForm">
          <div formGroupName="ingreso">
            <mat-form-field appearance="outline" style="margin-right: 20px">
              <mat-label>Factura</mat-label>
              <input matInput placeholder="Factura" formControlName="factura" name="factura" required>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Ubicación</mat-label>
              <input type="text"
                     placeholder="Ubicación"
                     matInput
                     required
                     [formControl]="ubicacionControl"
                     [matAutocomplete]="autoUbicacion">
              <mat-autocomplete #autoUbicacion="matAutocomplete">
                <mat-option *ngFor="let ubicacion of ubicaciones" [value]="ubicacion">
                  {{ubicacion}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </form>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="matcard">
    <mat-card-content style="width: 100%;">
      <div style="display: flex;flex-wrap: wrap;margin: 0" >

        <div [formGroup]="ingresoForm" style="margin: 0;display: table">
          <div formGroupName="ingreso" style="margin: 0">
            <div formGroupName="equipoAlmacen" style="margin: 0">

              <mat-form-field appearance="outline" style="margin-right: 20px">
                <mat-label>Equipo</mat-label>
                <input type="text"
                       placeholder="Elige un equipo"
                       matInput
                       required
                       [formControl]="myControl"
                       [matAutocomplete]="autoEquipo"
                >
                <mat-autocomplete #autoEquipo="matAutocomplete" [displayWith]="getOptionText">
                  <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                    {{option.nombre}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field appearance="outline" style="margin-right: 20px" >
                <mat-label>Marca</mat-label>
                <input matInput placeholder="Marca" formControlName="marca" name="marca" >
              </mat-form-field>
              <mat-form-field appearance="outline" style="margin-right: 20px" >
                <mat-label>Modelo</mat-label>
                <input matInput placeholder="Modelo" formControlName="modelo" name="modelo" >
              </mat-form-field>
              <mat-form-field appearance="outline" style="margin-right: 20px" >
                <mat-label>Talla</mat-label>
                <input matInput placeholder="Talla" formControlName="talla" name="talla" >
              </mat-form-field>


              <mat-form-field appearance="outline" style="margin-right: 20px" >
                <mat-label>Valoración</mat-label>
                <input matInput placeholder="Valoración" formControlName="valoracion" name="valoracion" >
              </mat-form-field>
              <mat-form-field appearance="outline" style="margin-right: 20px" >
                <mat-label>Observaciones</mat-label>
                <input matInput placeholder="Observaciones" formControlName="observaciones" name="observaciones">
              </mat-form-field>
              <mat-form-field appearance="outline" style="margin-right: 20px" >
                <mat-label>Cantidad</mat-label>
                <input matInput placeholder="Cantidad" formControlName="cantidad" name="cantidad" required>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Costo</mat-label>
                <input matInput placeholder="Costo" formControlName="costo" name="costo" required>
              </mat-form-field>
              <button mat-mini-fab color="primary" (click)="addElement()" style="margin-left: 2%">
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
        </div>


      </div>

    </mat-card-content>
  </mat-card>

</div>


<div class="container" *ngIf="addedIngreso.length>0" >

  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" style="margin-top: 0.4%;width: 80%">

    <ng-container matColumnDef="nombre" >
      <th mat-header-cell *matHeaderCellDef>Nombre</th>
      <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
    </ng-container>

    <ng-container matColumnDef="marca" >
      <th mat-header-cell *matHeaderCellDef>Marca</th>
      <td mat-cell *matCellDef="let element">{{ element.marca }}</td>
    </ng-container>
    <ng-container matColumnDef="modelo" >
      <th mat-header-cell *matHeaderCellDef>Modelo</th>
      <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
    </ng-container>
    <ng-container matColumnDef="valoracion" >
      <th mat-header-cell *matHeaderCellDef>Valoración</th>
      <td mat-cell *matCellDef="let element">{{ element.valoracion }}</td>
    </ng-container>

    <ng-container matColumnDef="observaciones" >
      <th mat-header-cell *matHeaderCellDef>Observaciones</th>
      <td mat-cell *matCellDef="let element">{{ element.observaciones }}</td>
    </ng-container>

    <ng-container matColumnDef="cantidad" >
      <th mat-header-cell *matHeaderCellDef>Cantidad</th>
      <td mat-cell *matCellDef="let element">{{ element.cantidad }}</td>
    </ng-container>

    <ng-container matColumnDef="costo" >
      <th mat-header-cell *matHeaderCellDef>Costo</th>
      <td mat-cell *matCellDef="let element">{{ element.costo }}</td>
    </ng-container>

    <ng-container matColumnDef="modificar">
      <th mat-header-cell *matHeaderCellDef> Editar </th>
      <td mat-cell *matCellDef="let element;let i=index">
        <button mat-icon-button color="primary" (click)="openDialogModify(i)">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="eliminar">
      <th mat-header-cell *matHeaderCellDef> Eliminar </th>
      <td mat-cell *matCellDef="let element;let i=index">
        <button mat-icon-button color="primary" (click)="deleteRegistro(i)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  </table>

</div>

<div style="margin-top: 2%;width: 100%" class="container" >
  <button mat-raised-button color="primary" >Agregar Ingreso</button>
</div>
